module.exports = __webpack_public_path__ + "static/media/4D_Icon.e26994f8.svg";